export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";